import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { OnboardingProps } from "../common";

export const BillingSettingsConsolidatedOnboarding = memo(
  function BillingSettingsConsolidatedOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    return (
      <RedoFeatureNotificationCard
        actionText="Got it"
        description="All billing settings are now consolidated under General > Billing, organized by product."
        onAction={handleComplete}
        onDismiss={handleDismiss}
        title="Billing settings have moved"
      />
    );
  },
);
